import styled from '@emotion/styled'
import { COLORS, PAGE_BREAKPOINTS } from 'parameters/index'

// TODO: get rid of these magic classes
export const LearnOverride = styled.div`
	width: 32%;
	@media only screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		width: 49%;
	}
	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		width: 100%;
	}
	.selectHeader {
		border-radius: 8px;
	}
	.selectCurrentValue {
		font-size: 18px;
		font-weight: normal;
		color: ${COLORS.SPANISH_GRAY};
	}
	.selectListItem {
		font-size: 18px;
		font-weight: normal;
		color: ${COLORS.SPANISH_GRAY};
	}
	svg {
		width: 16px;
		height: 9px;
		path {
			stroke: ${COLORS.KSU_PURPLE};
		}
	}
`
